import React from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { setViewLanguageModal } from 'features/auth/authSlice'
import ModalCloseButton from 'components/buttons/ModalCloseButton'
import { useTranslation } from 'react-i18next'
import { useAppLanguage } from 'i18n/useAppLanguage'


export default function LanguageModal() {

    const dispatch = useDispatch()
    const closeLanguageModal = () => dispatch(setViewLanguageModal(false))
    const { t } = useTranslation('settings')
    const { t: commonT } = useTranslation('common')
    const {
        currentLanguage,
        supportedLanguages,
        changeLanguage,
        isChangingLanguage,
        languageChangeError,
    } = useAppLanguage()

    const setLanguage = (value) => {

        if (value === currentLanguage || isChangingLanguage) return
        changeLanguage(value).then(closeLanguageModal).catch(() => {})
    }




    return (  
        <LanguageModalContainer role="dialog" aria-labelledby="language-modal-title">
            <ModalCloseButton
                handler={closeLanguageModal}
                top='10px'
                right='10px'
                size='40px'
                ariaLabel={commonT('close')}
                />
 
            
            <LanguageModalBody>
            <LanguageModalTitle id="language-modal-title">
                {t('language.title')}
            </LanguageModalTitle>  
                {supportedLanguages.map((languageOption) => (
                    <LanguageModalOption
                        as="button"
                        type="button"
                        key={languageOption.code}
                        lang={languageOption.locale}
                        selected={currentLanguage === languageOption.code}
                        aria-pressed={currentLanguage === languageOption.code}
                        disabled={isChangingLanguage}
                        onClick={() => setLanguage(languageOption.code)}
                    >
                        {t(`language.options.${languageOption.code}`)}
                    </LanguageModalOption>
                ))}
                {languageChangeError && (
                    <LanguageError role="alert">
                        {t('language.changeError')}
                    </LanguageError>
                )}
            </LanguageModalBody>
        </LanguageModalContainer> 
    )
}
 
const LanguageModalContainer = styled.div` 
    background-color: white;
    border-radius: 10px;
    padding: 20px;
    position: relative;
    width: 500px;
    height: 300px;

    @media (max-width: 600px) {
        width: calc(100vw - 32px);
        height: auto;
        min-height: 260px;
    }
`
 
const LanguageModalTitle = styled.div`
    color: var(--lightThemeFontColor);
    font-size: 20px;
    margin-bottom: 40px;
    margin-top: 30px;
`
 
const LanguageModalBody = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: center;
`
const LanguageModalOption = styled.div`
    background: white;
    font: inherit;
    color: var(--lightThemeFontColor);
    border: ${props => props.selected ? '2px solid var(--themeColor)' : '2px solid transparent'};    
    cursor: pointer;
    padding: 10px 20px;
    text-align: left;
    border-radius: 10px;
    margin-bottom: 10px;
    pointer-events: ${props => props.selected ? 'none' : 'auto'};

    &:hover {
        background-color: #ededed;
    }
`

const LanguageError = styled.p`
    color: #b42318;
    font-size: 14px;
    margin: 4px 0 0;
`
